export const openSubscriptionsPage = ({
    inSameTab = false,
    anchor = '',
    query = '',
}: { inSameTab?: boolean; anchor?: string; query?: string } = {}): Window | undefined | null => {
    const url = `/subscriptions/${query ? `?${query}` : ''}${anchor ? `#${anchor}` : ''}`;

    if (!inSameTab) {
        const tab = window.open(url);

        if (tab) {
            tab.focus();
        }

        return tab;
    }

    window.location.assign(url);
};
